module.exports = __webpack_public_path__ + "static/media/background_7.85ce9a7d.png";